<section class="wh-hero radius4">
  <img [src]="pymeHeroSrc" [alt]="pymeHeroAlt" />
</section>

<section class="wh-plans" id="plans">
  <ul class="wh-plans-list">
    <li *ngFor="let plan of plans" class="wh-plan radius4" [ngClass]="plan.colorClass">
      <div class="wh-plan-header">
        <h2 class="wh-plan-title">{{ plan.name }}</h2>
        <h3 class="wh-plan-subtitle">{{ plan.subtitle }}</h3>
        <dl class="wh-plan-features">
          <ng-container *ngFor="let f of plan.features">
            <dt>{{ f.label }}</dt>
            <dd>{{ f.value }}</dd>
          </ng-container>
        </dl>
        <div class="wh-plan-price">
          <span>{{ cart.symbol }}</span>
          <span>{{ plan.contracts[0].total | rackeoCurrency }}</span>
          <span *ngIf="cart.currencyHint" class="wh-currency-hint">{{ cart.currencyHint }}</span>
        </div>
        <p class="wh-plan-period">Anual</p>
      </div>
      <div class="wh-plan-contracts">
        <div *ngFor="let c of plan.contracts" class="wh-plan-contract">
          Contrato {{ c.years }} {{ c.years === 1 ? 'Año' : 'Años' }} — {{ cart.symbol }}{{ c.total | rackeoCurrency }} / {{ cart.symbol }}{{ c.perYear | rackeoCurrency }} por Año
        </div>
      </div>
      <div class="wh-plan-cta">
        <a [href]="cart.buildProductUrl(plan)" target="_blank" rel="noopener noreferrer">COMPRAR</a>
      </div>
    </li>
  </ul>
</section>

<section class="wh-page-tabs radius4" id="plans_text">
  <div class="tabs-wh-wrap">
    <header class="tabs-wh-head">
      <h1 class="tabs-wh-title">{{ pageTabsTitle }}</h1>
      <div class="tabs-wh-toolbar">
        <h2 class="tabs-wh-section-title">{{ tabSectionTitles[activeTab] }}</h2>
        <div class="tabs-wh-pills" role="tablist">
          <button
            *ngFor="let label of tabPills; let i = index"
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab === i"
            [class.is-active]="activeTab === i"
            (click)="setTab(i)">
            {{ label }}
          </button>
        </div>
      </div>
    </header>

    <div class="tabs-wh-body" [ngSwitch]="activeTab">
  <div *ngSwitchCase="0" class="tabs-wh-panel">
    <div class="wh-generales-layout">
      <div class="wh-features-list wh-features-generales">
        <article class="wh-feature-block">
          <img loading="lazy" src="assets/images/rackeo/web-hosting/generales/foto-mejores-caracteristicas.jpg" alt="Servidores Dual Intel Xeon con RAID 10 en el data center Rackeo" />
          <div>
            <h5>Última tecnología Cloud</h5>
            <p>En Rackeo hemos implementado nuestra plataforma Cloud <span *ngIf="site.isChile">única en Chile </span>de última tecnología, que garantiza Dual Intel Xeon Procesadores, <strong>RAID 10 Array</strong> disco duro, súper Micro componentes.</p>
          </div>
        </article>
        <article class="wh-feature-block">
          <img loading="lazy" src="assets/images/rackeo/web-hosting/generales/foto-soporte-247.jpg" alt="Soporte técnico Rackeo vía ticket y chat" />
          <div>
            <h5>Soporte</h5>
            <p>Contamos con soporte de <strong>Lunes a Viernes</strong> para ir monitoreando servidores y cualquier inconveniente que se presente. Contacte a su ejecutivo ingresando un ticket desde su área panel.</p>
          </div>
        </article>
        <article class="wh-feature-block">
          <img loading="lazy" src="assets/images/rackeo/web-hosting/generales/foto-garantia-reembolso.jpg" alt="Garantía de reembolso de 30 días en planes de hosting" />
          <div>
            <h5>Garantía de reembolso</h5>
            <p>Porque confiamos en nuestro servicio hemos implementado <strong>Garantía de Reembolso</strong>. Nuestros clientes cuentan con 30 días para pedir el reembolso de su dinero si no están conformes con el servicio entregado.</p>
          </div>
        </article>
        <article class="wh-feature-block">
          <img loading="lazy" src="assets/images/rackeo/web-hosting/generales/foto-caracteristicas-hosting.jpg" alt="Características ilimitadas: espacio web y cuentas de correo" />
          <div>
            <h5>Respaldos Ilimitados</h5>
            <p>Estos planes están diseñados para realizar respaldos diarios, semanales y mensuales. Esta es una gran herramienta para tener seguridad de que tus datos están totalmente a resguardo.</p>
          </div>
        </article>
      </div>
      <div class="wh-generales-image">
        <img loading="lazy" src="assets/images/rackeo/web-hosting/generales/data-center-propio.png" alt="Data Center propio: enlace fibra óptica, grupo electrógeno de respaldo, refrigeración redundante, UPS y balanceo de cargas" />
      </div>
    </div>
    <div class="wh-testimonial">
      <div class="wh-testimonial-quote">
        <h5>¿Por qué elegirnos?</h5>
        <p><span class="wh-testimonial-author">Ingrid Silva Cárcamo</span> «Les escribo para felicitarlos por sus servicios y agradecerles siempre su pronta respuesta a información solicitada, más que nada su buena paciencia para las personas que no somos muy idóneas en esto de Hosting y Dominios, como también los excelentes precios que mantienen en el tiempo, esto hace que no deje de usar sus servicios y de recomendarlos a quien los necesite.»</p>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="1" class="tabs-wh-panel">
    <div class="wh-features-list wh-features-carac">
      <article class="wh-feature-block">
        <img loading="lazy" src="assets/images/rackeo/web-hosting/caracteristicas/thumb-caracteristicas.png" alt="Características de Web Hosting Pyme Rackeo" />
        <div>
          <h5>Características Web Hosting Pyme</h5>
          <ul>
            <li>Panel de control más usado en el mundo y de muy fácil uso.</li>
            <li>Respaldos Ilimitados.</li>
            <li>Ilimitadas cuentas FTP, subdominios, cuentas de correo electrónico y redirecciones.</li>
          </ul>
        </div>
      </article>
      <article class="wh-feature-block">
        <img loading="lazy" src="assets/images/rackeo/web-hosting/caracteristicas/icon-cpanel.png" alt="Panel de control cPanel" />
        <div>
          <h5>Características del panel de control</h5>
          <ul>
            <li>La más reciente versión de panel de control cPanel.</li>
            <li>Directorios resguardados por contraseña, administración de navegación IPs, bloqueos IPs, etc.</li>
            <li>Administrador de archivos vía web, protección de Hotlink, protección de Leech, llaves GnuPG, etc.</li>
          </ul>
        </div>
      </article>
      <article class="wh-feature-block">
        <img loading="lazy" src="assets/images/rackeo/web-hosting/caracteristicas/icon-lenguajes-programacion.png" alt="Lenguajes de programación y bases de datos soportados" />
        <div>
          <h5>Programación y bases de datos</h5>
          <ul>
            <li>Planes creados en plataforma Cloud.</li>
            <li>MySQL y PostgreSQL con acceso phpMyAdmin.</li>
            <li>Acceso WebMail: Horde, SquirrelMail, RoundCube.</li>
            <li>Recibe tus emails en tu teléfono móvil vía IMAP. Protección anti-spam con SpamAssassin.</li>
          </ul>
        </div>
      </article>
      <article class="wh-feature-block">
        <img loading="lazy" src="assets/images/rackeo/web-hosting/caracteristicas/icon-email-corporativo.png" alt="Correo corporativo con IMAP, POP3 y webmail" />
        <div>
          <h5>E-mail</h5>
          <ul>
            <li>Recibe tus emails en tu teléfono móvil vía IMAP.</li>
            <li>WebMail: RoundCube, Horde, Squirrelmail y muchos más.</li>
            <li>Ilimitadas auto contestadores, alias, listas de correo, redirección de correo y MX.</li>
          </ul>
        </div>
      </article>
      <article class="wh-feature-block">
        <img loading="lazy" src="assets/images/rackeo/web-hosting/caracteristicas/icon-servicio-cliente.png" alt="Servicios adicionales opcionales de hosting" />
        <div>
          <h5>Servicios adicionales (opcionales)</h5>
          <ul>
            <li>Configuración de Google Apps, personalización de DNS, migración de hosting, IP dedicada, software de creación de SiteMaps, soporte VIP, instalación de Joomla o WordPress, paquete de themes Joomla y WordPress.</li>
          </ul>
        </div>
      </article>
    </div>
    <div class="wh-testimonial wh-testimonial-carac">
      <h5>¿Por qué elegirnos?</h5>
      <p><span class="wh-testimonial-author">Ingrid Silva Cárcamo</span> «Les escribo para felicitarlos por sus servicios y agradecerles siempre su pronta respuesta a información solicitada, más que nada su buena paciencia para las personas que no somos muy idóneas en esto de Hosting y Dominios, como también los excelentes precios que mantienen en el tiempo, esto hace que no deje de usar sus servicios y de recomendarlos a quien los necesite.»</p>
    </div>
  </div>

  <div *ngSwitchCase="2" class="tabs-wh-panel">
    <div class="wh-table-scroll">
      <table class="wh-comparison-table">
        <thead>
          <tr>
            <th scope="col"><span>Característica</span></th>
            <th scope="col"></th>
            <th scope="col" *ngFor="let plan of plans" [ngClass]="plan.colorClass">{{ plan.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of comparisonRows" [class.wh-comparison-section]="row.section">
            <ng-container *ngIf="row.section">
              <td colspan="5" class="wh-comparison-section-title">{{ row.section }}</td>
            </ng-container>
            <ng-container *ngIf="!row.section">
              <td class="wh-comparison-feature">{{ row.feature }}</td>
              <td class="wh-comparison-help">
                <span *ngIf="row.helpText" class="wh-help" [attr.title]="row.helpText">
                  <img loading="lazy" src="assets/images/rackeo/shared/ui/ui-icono-ayuda.png" alt="Más información" />
                </span>
              </td>
              <td class="wh-comparison-value">
                <img loading="lazy" *ngIf="row.p1 === 'check'" src="assets/images/rackeo/shared/ui/ui-icono-check.png" alt="Incluido" />
                <span *ngIf="row.p1 !== 'check'">{{ row.p1 }}</span>
              </td>
              <td class="wh-comparison-value">
                <img loading="lazy" *ngIf="row.p2 === 'check'" src="assets/images/rackeo/shared/ui/ui-icono-check.png" alt="Incluido" />
                <span *ngIf="row.p2 !== 'check'">{{ row.p2 }}</span>
              </td>
              <td class="wh-comparison-value">
                <img loading="lazy" *ngIf="row.p3 === 'check'" src="assets/images/rackeo/shared/ui/ui-icono-check.png" alt="Incluido" />
                <span *ngIf="row.p3 !== 'check'">{{ row.p3 }}</span>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <hr class="wh-divider" />

    <div class="wh-table-scroll">
      <table class="wh-comparison-prices">
        <thead>
          <tr>
            <th scope="col">Precios</th>
            <th scope="col" *ngFor="let plan of plans" [ngClass]="plan.colorClass">{{ plan.name }}<br /><small>{{ plan.subtitle }}</small></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pr of comparisonPrices">
            <td class="wh-price-label">{{ pr.label }}</td>
            <td>{{ cart.symbol }} {{ pr.plan1 }} total</td>
            <td>{{ cart.symbol }} {{ pr.plan2 }} total</td>
            <td>{{ cart.symbol }} {{ pr.plan3 }} total</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td *ngFor="let plan of plans">
              <a [href]="cart.buildProductUrl(plan)" target="_blank" rel="noopener noreferrer" class="wh-btn-comprar">Comprar</a>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
    </div>
  </div>
</section>

<section class="wh-cta-ayuda">
  <app-rackeo-cta-contact></app-rackeo-cta-contact>
</section>
